import { QueryEntity } from "@datorama/akita";
import { BehaviorSubject } from "rxjs";
import { singleton } from "tsyringe";

import InstagramPostEntity from "../entities/InstagramPostEntity";
import InstagramPostsStore, {
    InstagramPostsState,
} from "../stores/InstagramPostsStore";

@singleton()
class InstagramPostsQuery extends QueryEntity<InstagramPostsState> {
    active$: BehaviorSubject<InstagramPostEntity | undefined>;
    constructor(protected store: InstagramPostsStore) {
        super(store);
        this.active$ = new BehaviorSubject<InstagramPostEntity | undefined>(
            undefined
        );
        this.selectActive().subscribe(this.active$);
    }
    all$ = this.selectAll();
    paginationMeta$ = this.select((v) => v.paginationMeta);
    first$ = this.selectFirst();
    status$ = this.select((v) => v.status);
}

export default InstagramPostsQuery;
